import styled, { css } from 'styled-components';
import { COLORS } from './../../../../ui';
import { Icon } from './../../../Icon';

interface Props {
  selected?: boolean;
  disabled?: boolean;
}

export const Wrapper = styled.div`
  position: absolute;
  margin-top: 40px;
  user-select: none;
  z-index: 9;
  width: 240px;
  max-height: 300px;
  background-color: ${COLORS.WHITE};
  color: ${COLORS.BLACK};
  border: 1px solid ${COLORS.BORDER_GRAY};
  box-shadow: 0px 0px 8px ${COLORS.HOVER_GRAY};
  border-radius: 4px;
  padding: 5px;

  ${(props) => props.pos === 'right' && css`
    right: 16px;

    @media(min-width: 480px) {
      right: 34px;
    }
  `}
`;

Wrapper.displayName = 'Wrapper';

export const MonthYear = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  box-sizing: border-box;
  align-items: center;
`;

MonthYear.displayName = 'MonthYear';

export const Action = styled(Icon)`
  border-radius: 2px;
  cursor: pointer;
  svg {
    color: ${COLORS.BLACK};
  }

  &:hover {
    background-color: ${COLORS.AQUA_BLUE};
    svg {
      color: ${COLORS.WHITE};
    }
  }
`;

Action.displayName = 'Action';

export const Title = styled.div`
  font-size: 14px;
  font-weight: bold;
  color: ${COLORS.BLACK};
`;

Title.displayName = 'Title';

export const MonthDays = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

MonthDays.displayName = 'MonthDays';

export const Day = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: calc(100% / 7);
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s linear;

  ${(props: Props) => props.disabled && css`
    color: ${COLORS.TEXT_GRAY};
    pointer-events: none;
    opacity: .5;
  `}

  ${(props: Props) => props.selected && `
    background-color: ${COLORS.AQUA_BLUE};
    color: ${COLORS.WHITE};
  `}

  &:hover {
    background: ${COLORS.AQUA_BLUE};
    color: ${COLORS.WHITE};
  }
`;

Day.displayName = 'Day';
